import { Button, useTheme } from '@material-ui/core';
import { ReactNode } from 'react';

interface ButtonProps {
  backgroundColor?: string;
  className?: string;
  children?: ReactNode;
  onClick?: any;
  disabled?: boolean;
  sx?: any;
  type?: any;
}

export const CustomButton2 = ({
  backgroundColor = '',
  className = '',
  onClick,
  children,
  disabled = false,
  sx = {},
  type = 'button',
}: ButtonProps) => {
  const theme = useTheme();
  return (
    <Button
      className={className}
      type={type}
      sx={{
        fontFamily: 'Inter',
        backgroundColor,
        color: 'white',
        borderRadius: '6px',
        maxHeight: '36px',
        '&:hover': {
          backgroundColor: children === 'Cancel' ? 'lightgray' : theme.palette.primary.light,
          ...(children === 'Cancel' ? { color: 'white' } : {})
        },
        '&:disabled': {
          color: 'rgba(0, 0, 0, 0.26)',
          backgroundColor: 'rgba(0, 0, 0, 0.12);',
        },
        ...sx,
      }}
      onClick={onClick}
      disabled={disabled}>
      {children}
    </Button>
  );
};
